import React from "react";
import { connect } from "react-redux";
import { Button, Popup, TextArea } from "devextreme-react";
import DataGrid, { Column } from "devextreme-react/ui/data-grid";
import LoadingGif from "../../../../images/animacion2[18].gif";
import TableFilter from "../../../Shared/tableFilter.jsx";
import { filterData, filterType } from "../../../../helpers/filterHelper";
import {
  openCloseModalAgendar,
  showInfoGestionSolicitud,
  loadDataSelected,
  setWorkerSelected,
  loadDataGrid,
  setTipoSolicitud,
  updateDataGestionar,
  setCleanInbox,
  setSolicitudesEmpresaFiltrada,
  loadCargos,
} from "./actions";
import ModalAgendar from "./Componentes/ModalAgendar";
import { formatDateForFilter } from "../../../../helpers/dateFormat";
import LoadingOverlay from "../../../Shared/LoadingOverlay";
import validaciones from "../../../../helpers/validaciones";
import UserInfoColumn from "../../../Shared/UserInfoColumn";
import Moment from "moment";
import ModalVer from "../../../Shared/ModalVer"
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../helpers/rolAccess";
import { paths } from "../../../../config/routes";

class TableInboxSolicitudes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filtersLoaded: false,
      rejectModal: false,
      textArea: "",
      disabledButtonAgendar: true,
      openModalVer: false,
      dataModalVer: null
    };
    this.mainFilter = (_obj) => {
      const _arr = [
        {
          Icon: "2", name: "Pendiente de agendamiento", column: "estadoSolicitud", value: { text: "aprobado", value: [2, 5, 10] },
        },
        {
          Icon: "6", name: "Rechazadas por ejecutivo", column: "estadoSolicitud", value: { text: "rechazado", value: 9 },
        },
        {
          Icon: "b", name: "Agendadas", column: "estadoSolicitud", value: { text: "agendado", value: 4 },
        },

      ];
      if (_obj) { return _arr.find((e) => e.value.text === _obj.value.text); }
      return _arr;
    };
  }

  componentDidMount = (prevProps) => {
    // From: 1 año hacia atras
    // to: año actual.
    const data = {
      from: formatDateForFilter(Moment().subtract(1, "year")),
      to: formatDateForFilter(Moment()),
      companyRut: this.props.companyId,
      PetitionerRut: this.props.userData.RUT,
      StatusId: this.props.selectedTipoSolicitud.value.value,
    };
    this.props.dispatch(loadDataGrid(data));
    this.props.dispatch(loadCargos());
  }

  componentWillUnmount = () => {
    this.props.dispatch(setCleanInbox());
  }

  componentDidUpdate = (prev) => {
    if (this.props.selectedSolicitudShow && prev.selectedSolicitudShow !== this.props.selectedSolicitudShow) {
      this.handleModalVer()
    }
    if (prev.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  handleViewGestionar = (Id) => {
    this.props.dispatch(loadDataSelected(Id));
  }

  handleCloseGestionarsolicitud = () => {
    this.props.dispatch(showInfoGestionSolicitud(false));
    this.setState({ disabledButtonAgendar: true });
  }

  renderInfoBoxEnterprise = () => {
    if (!this.props.selectedSolicitud) return ""
    const {
      Comment,
      CompanyName,
      CompanyRut,
      RequestTypeDescription,
      ProposalDate,
      ProposalDateEnd,
      PetitionerName,
      PetitionerRut,
      Pools,
      WorkersQuota,
      OtherWorkerPosition,
      CostCenter,
      AdditionalExams,
      PsychologicalExams,
      Workers,
      WorkerCode,
    } = this.props.selectedSolicitud;
    const { ListaCargos } = this.props.listaCargos;
    const _isAnyScheduling = Workers.find((e) => e.IsScheduling === true);
    const _cargo = ListaCargos.find((e) => WorkerCode && e.CodigoCargo && e.CodigoCargo === WorkerCode.toString());
    const _firstBenefit = [...Pools, ...AdditionalExams, ...PsychologicalExams].find(e => e.AchsOfficeDescription);
    const defaultCityDescription = _firstBenefit && _firstBenefit.AchsOfficeDescription ? _firstBenefit.AchsOfficeDescription : "";
    return (
      <div>
        <div className="row infoEnterpriseBox">
          <div className="col-12">
            <div className="row">
              <div className="col-1 zero">
                <Button
                  className="slimButton"
                  icon="arrowleft"
                  type="success"
                  text="Volver"
                  onClick={() => this.handleCloseGestionarsolicitud()}
                />
              </div>
              <div className="col-1">
                Empresa solicitante:
              </div>
              <div className="col-2">
                <UserInfoColumn
                  nombre={CompanyName || ""}
                  rut={CompanyRut || ""}
                />
              </div>
              <div className="col-1">
                Tipo Evaluación:
              </div>
              <div className="col-2">
                {RequestTypeDescription || ""}
              </div>
              <div className="col-1">
                Fecha Preferente:
              </div>
              <div className="col-2">
                {
                  (ProposalDate ? Moment(ProposalDate).format("DD/MM/YYYY") : "")
                  + (ProposalDateEnd ? ` - ${Moment(ProposalDateEnd).format("DD/MM/YYYY")}` : "")}
              </div>
              <div className="col-1">
                Centro:
              </div>
              <div className="col-1">
                {defaultCityDescription}
              </div>
            </div>
            <div className="row">
              <div className="col-1 zero">
                {!_isAnyScheduling &&
                  <Button
                    className="slimButton"
                    onClick={() => this.setState({ rejectModal: true })}
                    type="danger"
                    text="Rechazar"
                  />
                }
              </div>
              <div className="col-1">
                Solicitante:
              </div>
              <div className="col-2">
                <UserInfoColumn
                  nombre={PetitionerName || ""}
                  rut={PetitionerRut || ""}
                />
              </div>
              <div className="col-1">
                Cargo:
              </div>
              <div className="col-2">
                {_cargo && _cargo.DescripcionCargo ? _cargo.DescripcionCargo : OtherWorkerPosition}
              </div>
              <div className="col-1">
                Centro de costos:
              </div>
              <div className="col-2">
                {CostCenter || ""}
              </div>
              <div className="col-1">
                Trabajadores:
              </div>
              <div className="col-1">
                {WorkersQuota || "0"}
              </div>
            </div>
            <div className="row">
              <div className="col-1 zero">
                {(!_isAnyScheduling && this.state.disabledButtonAgendar === true) &&
                  <Button
                    className="slimButton"
                    onClick={() => this.setState({ disabledButtonAgendar: false })}
                    type="success"
                    text="Agendar"
                  />
                }
              </div>
              <div className="col-1">
                Baterías:
              </div>
              <div className="col-2">
                {Pools.map((e, i) => <span key={`exams_1_${i}`} className="span_exams">{e.Description}</span>)}
              </div>
              <div className="col-1">
                Prestaciones médicas:
              </div>

              <div className="col-2">
                {AdditionalExams ?
                  AdditionalExams.map((e, i) => <span key={`exams_2_${i}`} className="span_exams">{e.ExamDescription}</span>)
                  : ""
                }
              </div>
              <div className="col-1">
                Evaluaciones psicológicas:
              </div>
              <div className="col-2">
                {PsychologicalExams ?
                  PsychologicalExams.map((e, i) => <span key={`exams_3_${i}`} className="span_exams">{e.ExamDescription}</span>)
                  : ""
                }
              </div>
              <div className="col-1">
                Observaciones:
              </div>
              <div className="col-2">
                {Comment ? Comment : ""
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderTrabajadoresDataGrid() {
    const { selectedSolicitud } = this.props;
    if (!this.props.selectedSolicitud) return "";
    const _isAnyScheduling = selectedSolicitud.Workers.find((e) => e.IsScheduling === true);
    return (
      <div>
        {this.props.isLoading && <LoadingOverlay />}
        <DataGrid
          dataSource={selectedSolicitud && selectedSolicitud.Workers}
          onRowPrepared={this.heightRow}
          showBorders={false}
          showColumnLines={false}
          showRowLines={false}
          noDataText=""
          className="custom-table"
          rowAlternationEnabled
          hoverStateEnabled={false}
          activeStateEnabled={false}
          focusStateEnabled={false}
          onContentReady={(e) => {
            if (e.component.totalCount() === 0) {
              const config = {};
              config.addClass = "table-margin";
              const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
              const element = validaciones.noDataDOMElement(config, "Sin solicitudes");
              noDataSpan.appendChild(element);
            }
          }}
          loadPanel={{
            enabled: true,
            showPane: true,
            showIndicator: true,
            indicatorSrc: LoadingGif,
            text: "Cargando...",
          }}
          paging={{
            pageSize: 5,
          }}
          pager={{
            showInfo: true,
            visible: true,
            infoText: (page, total, items) => `Página ${page} de ${total} (${items} resultados)`,
          }}
        >
          <Column
            caption="Nombre"
            allowSearch
            alignment="center"
            cellComponent={(props) => (
              <div>
                {props.data.Name ? props.data.Name
                  :
                  <div>Sin Nombre</div>}
              </div>
            )}
          />
          <Column
            caption="Número de documento"
            allowSearch
            alignment="center"
            cellComponent={(props) => (
              <div>
                {props.data.DocumentNumber ? props.data.DocumentNumber
                  :
                  <div></div>}
              </div>
            )}
          />
          <Column
            caption="Teléfono"
            allowSearch
            alignment="center"
            dataField="Phone"
          />
          <Column
            caption="Correo"
            allowSearch
            alignment="center"
            dataField="Mail"
          />
          <Column
            caption="Agendamiento"
            alignment="center"
            cellComponent={(props) => (
              <div>
                {!props.data.IsScheduling ? <Button
                  text="Agendar"
                  type="success"
                  className="slimButton"
                  disabled={
                    !_isAnyScheduling && this.state.disabledButtonAgendar === true ?
                      true
                      : !_isAnyScheduling && this.state.disabledButtonAgendar === false ?
                        false
                        : !_isAnyScheduling
                  }
                  onClick={() => this.handleWorkerModal(props)}
                />
                  :
                  <div>Agendado</div>}
              </div>
            )}
          />
        </DataGrid>
      </div>
    );
  }

  handleWorkerModal(data) {
    this.props.dispatch(setWorkerSelected(data.data.Id));
    this.props.dispatch(openCloseModalAgendar(true));
  }

  doGetComplains = (data) => {
    const filtros = {
      from: formatDateForFilter(Moment().subtract(1, "year")),
      to: formatDateForFilter(Moment()),
      companyRut: this.props.companyId,
      PetitionerRut: this.props.userData.RUT,
      StatusId: this.props.selectedTipoSolicitud.value.value,
    };
    if (validaciones.emptyText(this.props.sucursalId)) {
      filtros.idSucursal = this.props.sucursalId;
    }
    this.props.dispatch(loadDataGrid(filtros));
  }

  handleFilterChange = (text, filters) => {
    let currentFilters = [...filters];
    const _estadoSolicitud = currentFilters.find((e) => e.column === "estadoSolicitud");
    if (_estadoSolicitud && this.props.selectedTipoSolicitud.value.value !== _estadoSolicitud.value.value) {
      this.props.dispatch(setTipoSolicitud(this.mainFilter(_estadoSolicitud)));
      this.doGetComplains();
    } else {
      currentFilters = currentFilters.map((e) => e.column !== "estadoSolicitud" ? e : null).filter((e) => e);
      if (text) {
        currentFilters.push({
          column: "Id", filterValue: null, value: { text, value: text }, type: filterType.search,
        });
      }
      const ProposalDate = currentFilters.length > 0 ? currentFilters.filter((f) => f.column === "ProposalDate") : [];
      if (ProposalDate.length > 0) {
        const pivotFecha = ProposalDate.find((i) => i.column === "ProposalDate");
        let FechaDesde = null;

        if (this.state.doFilterProposalDate === true) {
          FechaDesde = this.state.ProposalDate;
        } else {
          FechaDesde = formatDateForFilter(Moment().subtract(1, "year"));
        }
        const dateIsBefore = Moment(pivotFecha.value.value.from).isBefore(Moment(FechaDesde));
        // llamado al api cuando las fechas son menores con respecto a las que mando por primera vez
        if (dateIsBefore === true) {
          const data = {
            from: formatDateForFilter(Moment(pivotFecha.value.value.from)),
            to: formatDateForFilter(Moment(pivotFecha.value.value.to)),
          };
          this.doGetComplains(data);
          this.setState({
            doFilterProposalDate: true,
            ProposalDate: pivotFecha.value.value.from,
          });
        }
      }
      if (this.state.doFilterProposalDate && ProposalDate.length === 0) {
        // vuelvo a la carga de datos inicial. al limpiar el rango de fecha que fue menor a la orginal
        const data = {
          from: formatDateForFilter(Moment().subtract(1, "year")),
          to: formatDateForFilter(Moment()),
        };
        this.doGetComplains(data);
        this.setState({
          doFilterProposalDate: false,
          ProposalDate: null,
        });
      }
      const newData = filterData(this.props.listaSolicitudes, currentFilters);
      if (currentFilters.length > 0) {
        this.props.dispatch(setSolicitudesEmpresaFiltrada(newData));
      } else {
        this.props.dispatch(setSolicitudesEmpresaFiltrada(this.props.listaSolicitudes));
      }
    }
  }

  renderSolicitudesDataGrid() {
    const {
      selectedTipoSolicitud,
    } = this.props;
    const textStatus = selectedTipoSolicitud.value && selectedTipoSolicitud.value.text ? selectedTipoSolicitud.value.text : null;
    const { listaSolicitudesFiltrada } = this.props;
    const columns = () => {
      const _columns = [];
      _columns.push(
        {
          caption: "N° de Solicitud",
          allowSearch: true,
          alignment: "center",
        },
        {
          caption: "Empresa",
          allowSearch: true,
          alignment: "left",
        },
        {
          caption: "Aprobador",
          allowSearch: true,
          alignment: "left",
        }
      );
      if (textStatus !== "rechazado") {
        _columns.push(
          {
            caption: "Fecha de cita deseada",
            allowSearch: true,
            alignment: "center",
            dataType: "date",
            format: "dd/MM/yyyy",
          },
          {
            caption: "Cantidad de trabajadores",
            allowSearch: true,
            alignment: "center",
          }
        );
      }
      if (textStatus === "rechazado") {
        _columns.push(
          {
            caption: "Fecha de rechazo",
            allowSearch: true,
            alignment: "center",
            dataType: "date",
            format: "dd/MM/yyyy",
          },
          {
            caption: "Cantidad de trabajadores",
            allowSearch: true,
            alignment: "center",
          },
          {
            caption: "Tipo de evaluación",
            allowSearch: true,
            alignment: "center",
          },
          {
            caption: "Baterías/Prestaciones",
            allowSearch: true,
            alignment: "center",
          }
        );
      }
      if (textStatus === "agendado") {
        _columns.push(
          {
            caption: "Fecha de aprobación",
            allowSearch: true,
            alignment: "center",
            dataType: "date",
            format: "dd/MM/yyyy",
          }
        );
      }
      if (textStatus === "aprobado") {
        _columns.push(
          {
            caption: "Fecha de aprobación",
            allowSearch: true,
            alignment: "center",
            dataType: "date",
            format: "dd/MM/yyyy",
          }
        );
      }
      _columns.push({
        caption: "",
        allowSearch: true,
        alignment: "center",
      })
      return _columns;
    };
    const DataRow = (rowInfo) => {
      const _data = rowInfo.data ? rowInfo.data : null;
      return (<tbody className="dx-row">
        <tr className="main-row">
          <td style={{ textAlign: "center" }}>
            {_data.Id ? _data.Id : ""}
          </td>
          <td>
            <UserInfoColumn
              nombre={_data.CompanyName ? _data.CompanyName : ""}
              rut={_data.CompanyRut ? _data.CompanyRut : ""}
            />
          </td>
          <td>
            <UserInfoColumn
              nombre={_data.AuthorizedName ? _data.AuthorizedName : ""}
              rut={_data.AuthorizedRut ? _data.AuthorizedRut : ""}
            />
          </td>
          {(textStatus !== "rechazado") &&
            <td style={{ textAlign: "center" }}>
              {_data.ProposalDate ? Moment(_data.ProposalDate).format("L") + "-" + Moment(_data.ProposalDateEnd).format("L") : ""}
            </td>
          }
          {(textStatus === "rechazado") &&
            <td style={{ textAlign: "center" }}>{_data.RejectCallCenterDate ? Moment(_data.RejectCallCenterDate).format("L") : ""}</td>
          }
          <td style={{ textAlign: "center" }}>{_data.WorkersQuota ? _data.WorkersQuota : "0"}</td>
          {(textStatus !== "rechazado") &&
            <td style={{ textAlign: "center" }}>{_data.ApprovalDate ? Moment(_data.ApprovalDate).format("L") : ""}</td>
          }
          {(textStatus === "rechazado") ?
            <React.Fragment><td style={{ textAlign: "center" }}>{_data.RequestTypeDescription}</td>
              <td style={{ textAlign: "center" }}>{_data.Pools}</td></React.Fragment>
            :
            ((textStatus !== "aprobado" && textStatus !== "agendado") && <td style={{ textAlign: "center" }}>{_data.Pools}</td>)
          }
          {textStatus !== "agendado" && textStatus !== "rechazado" ?
            <td style={{ textAlign: "center" }}>
              <Button
                text="Gestionar"
                type="success"
                className="slimButton"
                onClick={() => this.handleViewGestionar(_data.Id)}
              />
            </td>
            :
            <td style={{ textAlign: "center" }}>
              <Button
                text="Ver"
                type="success"
                className="slimButton"
                //disabled={(_data.StatusId === 10)}
                onClick={() => this.openModalVer(_data)}
              />
            </td>
          }
        </tr>
        {(textStatus === "rechazado") &&
          <tr className="notes-row">
            <td colSpan="4">
              <div className="row">
                <div className="col-2" style={{ fontWeight: "bold" }}>Comentario:</div>
                <div className="col-10">{_data.RejectComment}</div>
              </div>
            </td>
          </tr>
        }
      </tbody>);
    };
    return (
      <div>
        {this.props.isLoading && <LoadingOverlay />}
        <div className="row">
          <div className="col-12">
            <DataGrid
              dataSource={listaSolicitudesFiltrada}
              onRowPrepared={this.heightRow}
              showBorders={false}
              showColumnLines={false}
              showRowLines={false}
              noDataText=""
              className="custom-table agendamiento"
              rowAlternationEnabled
              hoverStateEnabled={false}
              activeStateEnabled={false}
              focusStateEnabled={false}
              onContentReady={(e) => {
                if (e.component.totalCount() === 0) {
                  const config = {};
                  config.addClass = "table-margin";
                  const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
                  const element = validaciones.noDataDOMElement(config, "Sin solicitudes");
                  noDataSpan.appendChild(element);
                }
              }}

              loadPanel={{
                enabled: false,
                showPane: true,
                showIndicator: true,
                indicatorSrc: LoadingGif,
                text: "Cargando...",
              }}
              paging={{
                pageSize: 20,
              }}
              pager={{
                showInfo: true,
                visible: true,
                infoText: (page, total, items) => `Página ${page} de ${total} (${items} resultados)`,
              }}
              columns={columns()}
              rowComponent={DataRow}
            />
          </div>
        </div>
      </div>
    );
  }

  rejectSolicitud = async () => {
    const _data = {
      RequestId: this.props.selectedSolicitud && this.props.selectedSolicitud.Id ? this.props.selectedSolicitud.Id : 0,
      RequestStatus: 9,
      Comment: this.state.textArea,
    };
    await this.props.dispatch(updateDataGestionar(_data));
    this.doGetComplains();
    this.setState({ rejectModal: false, textArea: "" });
  }

  handleModalVer = () => {
    const {
      Pools,
      AdditionalExams,
      PsychologicalExams,
      Workers,
      CompanyName,
      CostCenter,
      PetitionerName,
      PetitionerRut,
      ProposalDate,
      ProposalDateEnd,
      WorkersQuota,
      RequestTypeDescription,
      defaultCityDescription
    } = this.props.selectedSolicitudShow;
    let _data = {};
    const _firstBenefit = [...Pools, ...AdditionalExams, ...PsychologicalExams].find(e => e.AchsOfficeDescription);
    _data.defaultCityDescription = _firstBenefit && _firstBenefit.AchsOfficeDescription ? _firstBenefit.AchsOfficeDescription : "";
    const baterias = Pools ? [{ key: `Baterías (${Pools.length})`, items: Pools.map((e) => e.Description) }] : [];
    const examenes = AdditionalExams ? [{ key: `Prestaciones médicas (${AdditionalExams.length})`, items: AdditionalExams.map((e) => e.ExamDescription) }] : [];
    const psicologicos = PsychologicalExams ? [{ key: `Evaluaciones psicológicas (${PsychologicalExams.length})`, items: PsychologicalExams.map((e) => e.ExamDescription) }] : [];
    _data.benefits = [...baterias, ...examenes, ...psicologicos];
    _data.workers = Workers ? Workers : [];
    _data.info = {
      CompanyName: CompanyName ? CompanyName : "",
      CostCenter: CostCenter ? CostCenter : "",
      PetitionerName: PetitionerName ? PetitionerName : "",
      PetitionerRut: PetitionerRut ? PetitionerRut : "",
      ProposalDate: ProposalDate ? ProposalDate : "",
      ProposalDateEnd: ProposalDateEnd ? ProposalDateEnd : "",
      WorkersQuota: WorkersQuota ? WorkersQuota : "",
      RequestTypeDescription: RequestTypeDescription ? RequestTypeDescription : "",
      defaultCityDescription: defaultCityDescription ? defaultCityDescription : ""
    }
    this.setState({ openModalVer: true, dataModalVer: _data })
  }

  openModalVer = (row) => {
    this.props.dispatch(loadDataSelected(row.Id, true));
  }

  closeModalVer = () => {
    this.setState({ openModalVer: false, dataModalVer: null })
  }

  render() {
    const { filtrosSolicitudes } = this.props;
    const {
      selectedTipoSolicitud,
    } = this.props;
    let newFiltros;
    const textStatus = selectedTipoSolicitud.value && selectedTipoSolicitud.value.text ? selectedTipoSolicitud.value.text : null;
    if (textStatus !== "rechazado") {
      newFiltros = filtrosSolicitudes ? filtrosSolicitudes.filter((x) => x.column !== "RejectCallCenterDate") : null;
    } else if (textStatus !== "aprobado") {
      newFiltros = filtrosSolicitudes ? filtrosSolicitudes.filter((x) => x.column !== "ApprovalDate") : null;
    }
    return (
      <div>
        {this.props.selectedSolicitud && this.props.dataSelected && <ModalAgendar />}
        <ModalVer
          data={this.state.dataModalVer}
          isOpen={this.state.openModalVer}
          close={this.closeModalVer}
        />
        <div className="table-wrapper">
          {this.props.gestionarSolicitudStatus && this.renderInfoBoxEnterprise()}
          {this.props.gestionarSolicitudStatus === false && <div className="row">
            <div className="col-12">
              <TableFilter
                placeholder="Buscar solicitud"
                onChange={this.handleFilterChange}
                filters={newFiltros}
                show
                buttons={
                  {
                    filter: { buttonName: "iconFilter", visible: true, buttonAction: null },
                    document: null,
                    download: { buttonName: "iconDownload", visible: false, buttonAction: null },
                    newItem: null,
                  }
                }
                selectedMainFilter={this.props.selectedTipoSolicitud}
                mainFilter={this.mainFilter()}
              />
            </div>
          </div>}
          {this.props.gestionarSolicitudStatus ? this.renderTrabajadoresDataGrid() : this.renderSolicitudesDataGrid()}

        </div>
        <Popup
          visible={this.state.rejectModal}
          showTitle
          title="Gestionar solicitud"
          onHiding={() => this.setState({ rejectModal: false })}
          maxWidth={500}
          maxHeight={300}
          dragEnabled={false}
          style={{ borderBottom: 0 }}
          className="modalGestionarSolicitud"
        >
          <div>
            <div className="row">
              <div className="col-12">
                <h3><p className="text-left">Razón del rechazo de la solicitud</p></h3>
                <TextArea
                  height={120}
                  maxLength={200}
                  value={this.state.textArea}
                  valueChangeEvent="keyup"
                  onValueChanged={(v) => this.setState({ textArea: v.value })}
                />
              </div>
            </div>
            <div className="row bottom-button">
              <div className="col-6">
                <Button
                  onClick={() => this.setState({ rejectModal: false })}
                  type="danger"
                  text="Cancelar"
                  disabled={this.props.isLoading}
                />
              </div>
              <div className="col-6">
                <Button
                  onClick={() => this.rejectSolicitud()}
                  type="success"
                  text="Enviar"
                  disabled={!this.state.textArea.trim().length || this.props.isLoading}
                />
              </div>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  isLoading: state.inboxSolicitudes.isLoading,
  listaSolicitudes: state.inboxSolicitudes.listaSolicitudes,
  listaSolicitudesFiltrada: state.inboxSolicitudes.listaSolicitudesFiltrada,
  listaCargos: state.inboxSolicitudes.listaCargos,
  filtrosSolicitudes: state.inboxSolicitudes.filtrosSolicitudes,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  userData: state.global.userData,
  gestionarSolicitudStatus: state.inboxSolicitudes.gestionarSolicitudStatus,
  selectedSolicitud: state.inboxSolicitudes.selectedSolicitud,
  dataSelected: state.inboxSolicitudes.dataSelected,
  selectedTipoSolicitud: state.inboxSolicitudes.selectedTipoSolicitud,
  selectedSolicitudShow: state.inboxSolicitudes.selectedSolicitudShow,
  userAccessIds: state.global.userAccessIds,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TableInboxSolicitudes);
